<template>
  <div class="gamelist_box">
    <div class="gamelist">
      <div class="condition">
        <div class="condition_select">
          <router-link class="new_btn CU" tag="div" to="/Foundapp">
            <img class="set_img" src="@/img/set_img.png" alt="" />
            {{ $t("gamelist.addApp") }}
          </router-link>
        </div>
        <div class="seek_box">
          <div class="seek">
            <div class="seek_url">
              <img class="seek_img" src="@/img/seek.png" alt="" />
            </div>
            <div class="seek_input_box">
              <input
                @input="handleInput"
                v-model="mytext"
                :placeholder="$t('gamelist.appname')"
                class="seek_input TGA_INPUT"
                type="text"
              />
            </div>
          </div>
          <!-- <div class="seek_btn CU">搜索</div> -->
        </div>
      </div>
      <div class="gamelist_table">
        <a-config-provider>
          <template
            v-if="datalist == '' && !tableloading"
            #renderEmpty
            style=""
          >
            <div style="text-align: center; margin-top: 224px">
              <img src="@/img/kong.png" alt="" />
              <p>
                {{ $t("gamelist.began") }}
                <router-link
                  class="CU"
                  style="color: #4990fa"
                  tag="span"
                  to="/Foundapp"
                  >{{ $t("gamelist.create") }}</router-link
                >
                {{ $t("gamelist.createapp") }}
              </p>
            </div>
          </template>

          <template v-if="datalist == '' && tableloading" style="">
            <div style="text-align: center; margin-top: 224px">
              <loading></loading>
            </div>
          </template>

          <a-table
            :columns="columns"
            :data-source="datalist"
            :rowKey="
              (record, index) => {
                return index;
              }
            "
          >
            <template slot="id" slot-scope="text, record, index">
              {{ 10000 - -index }}
            </template>
            <template slot="appName" slot-scope="text, record, index">
              {{ text }}
            </template>

            <template slot="checkState" slot-scope="text, record, index">
              {{ text }}
            </template>

            <template slot="version" slot-scope="text, record, index">
              {{ text }}
            </template>
            <template slot="lastModified" slot-scope="text, record, index">
              {{ text }}
            </template>

            <template slot="btn" slot-scope="text, record, index">
              <span style="margin-left: 10px">
                <router-link
                  :to="{
                    path: '/appInfo',
                    query: { appId: record.appId, id: record.id },
                  }"
                  >{{ $t("gamelist.admi") }}</router-link
                >
              </span>

              <span style="margin-left: 10px">
                <a-popconfirm
                  :title="$t('gamelist.isDelete')"
                  :ok-text="$t('gamelist.ok')"
                  :cancel-text="$t('gamelist.cancel')"
                  @confirm="confirm(record.id)"
                  @cancel="cancel"
                >
                  <a href="#">{{ $t("gamelist.delete") }}</a>
                </a-popconfirm>
              </span>
            </template>
          </a-table>
        </a-config-provider>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import loading from "@/components/loading/loading.vue";
// const columns = ;
function NewData(data) {
  var d = new Date(data);
  var year = d.getFullYear(); //年
  var month = d.getMonth() + 1; //月
  var day = d.getDate(); //日
  var hh = d.getHours(); //时
  var mm = d.getMinutes(); //分
  var ss = d.getSeconds(); //秒
  var clock = year + "-";
  if (month < 10) clock += "0";
  clock += month + "-";
  if (day < 10) clock += "0";
  clock += day + " ";
  if (hh < 10) clock += "0";
  clock += hh + ":";
  if (mm < 10) clock += "0";
  clock += mm + ":";
  if (ss < 10) clock += "0";
  clock += ss;
  return clock;
}

export default {
  components: {
    loading,
  },
  data() {
    return {
      tableloading: true,
      SelectModel: 0,
      ArrSelect: this.$t("gamelist.arrSelect"),
      mytext: "",
      datalist: [],
      list: [],
      columns: [
        {
          title: this.$t("gamelist.appId"),
          dataIndex: "appId",
          key: "appId",
          scopedSlots: { customRender: "appId" },
          width: "25%",
        },
        {
          title: this.$t("gamelist.appnames"),
          dataIndex: "appName",
          key: "appName",
          width: "35%",
          scopedSlots: { customRender: "appName" },
          customRender: (text, record) => {
            var data = text;
            return text;
          },
        },
        {
          title: this.$t("gamelist.lastModified"),
          dataIndex: "updateTime",
          key: "updateTime",
          ellipsis: true,
          width: "15%",
          customRender: (text, record) => {
            var data = NewData(text);
            return data;
          },
        },
        {
          title: this.$t("gamelist.btn"),
          dataIndex: "btn",
          key: "btn",
          scopedSlots: { customRender: "btn" },
        },
      ],
      description: "add",
      pagination: {
        total: 0,
        pageSize: 5, //每页中显示10条数据
      },
    };
  },

  created() {
    if (
      localStorage.getItem("roleName") &&
      localStorage.getItem("roleName").includes("GAME_DEVELOPER")
    ) {
      this.$router.push({
        path: "/game_management",
      });
    }
    this.load_list();
  },
  methods: {
    ...mapActions("user", ["tipMessage"]),
    ...mapActions("game", ["AppList", "AppDelete"]),

    async load_list() {
      var res = await this.AppList({
        $axios: this.$axios,
      });
      if (res.code == 200) {
        this.tableloading = false;
        this.datalist = res.data;
        this.list = res.data;
      }
    },
    changeSelect() {
      var self = this;
      if (self.SelectModel == 0) {
        this.datalist = this.list;
        return;
      }
      var newlist = this.list.filter(
        (item) => item.checkState == self.SelectModel - 1
      );
      this.datalist = newlist;
    },
    // 模糊查询
    handleInput() {
      var newlist = this.list.filter((item) => {
        const name = item.appName.toLowerCase();
        if (name.indexOf(this.mytext.toLowerCase()) > -1) {
          return item;
        }
      });
      this.datalist = newlist;
    },
    async confirm(id) {
      var res = await this.AppDelete({
        $axios: this.$axios,
        id: id,
      });
      if (res.code == 200) {
        this.load_list();
        this.$message.success(this.$t("gameinfo.rank.delete_success"));
      } else {
        this.$message.error(this.$t("gameinfo.rank.delete_error"));
      }
    },
  },
};
</script>

<style scoped="scoped">
.gamelist_box {
  margin: 59px auto 0;
  width: 1520px;
  height: 750px;
  background-color: #ffffff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
.gamelist {
  width: 100%;
  height: 100%;
}
.condition {
  width: 1522px;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 40px;
  background-color: #f5f7fa;
  border-bottom: solid 1px #e5e5e5;
  margin-bottom: 25px;
}
.condition_select {
  display: flex;
  align-items: center;
}
.condition_text {
  color: #666666;
  font-size: 14px;
  margin-right: 23px;
}
.new_btn {
  margin-left: 20px;
  width: 120px;
  height: 40px;
  background-color: #4990fa;
  border-radius: 4px;
  color: #ffffff;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
}
.new_btn .set_img {
  width: 14px;
  height: 14px;
  margin-right: 6px;
}
.gamelist_table {
  width: 100%;
  padding: 0 32px;
}
.seek_box {
  display: flex;
  align-items: center;
}

.seek {
  width: 421px;
  height: 40px;
  background-color: #ffffff;
  border-radius: 4px;
  /* border: solid 1px #e5e5e5; */
  display: flex;
  align-items: center;
  position: relative;
}

.seek_url {
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  height: 100%;

  display: flex;
  align-items: center;
  padding: 0 13px;
}
.seek_img {
  width: 15px;
  height: 15px;
}
.seek_input_box {
  position: relative;
  width: 100%;
  height: 100%;
}
.seek_input {
  padding-left: 40px;
  width: 100%;
  height: 100%;
}
.seek_btn {
  width: 90px;
  height: 40px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #e6e6e6;
  color: #666666;
  font-size: 14px;
  margin-left: 20px;
  text-align: center;
  line-height: 40px;
}

.gamelist_box .aaaa {
  width: 176px;
  color: rgb(28, 28, 28);
}
</style>



// WEBPACK FOOTER //
// src/components/app_management.vue